'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _FormMessageStyled = require('./styles/FormMessageStyled');

var _theme = require('./styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(0, _reactackleCore.registerDefaultComponentTheme)('form', _theme2.default);

var propTypes = {
  /**
   * Determines error text of the form
   */
  errorMessage: _propTypes2.default.string,
  /**
   * Specify function that will be called on Form submit
   */
  onSubmit: _propTypes2.default.func
};
var defaultProps = {
  errorMessage: '',
  onSubmit: _reactackleCore.noop
};

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this));

    _this.domNode = null;

    _this._scrollToError = _this._scrollToError.bind(_this);
    _this._handleSubmit = _this._handleSubmit.bind(_this);
    _this._saveRef = _this._saveRef.bind(_this);
    return _this;
  }

  _createClass(Form, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.errorMessage) this._scrollToError();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.errorMessage) this._scrollToError();
    }
  }, {
    key: '_scrollToError',
    value: function _scrollToError() {
      if (this.domNode) {
        this.domNode.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }, {
    key: '_saveRef',
    value: function _saveRef(ref) {
      this.domNode = ref;
    }
  }, {
    key: '_handleSubmit',
    value: function _handleSubmit(e) {
      e.preventDefault();
      if (this.props.onSubmit) this.props.onSubmit();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          errorMessage = _props.errorMessage,
          children = _props.children;

      var message = errorMessage ? _react2.default.createElement(
        _FormMessageStyled.FormMessageStyled,
        null,
        errorMessage
      ) : null;

      return _react2.default.createElement(
        'form',
        { ref: this._saveRef, onSubmit: this._handleSubmit },
        message,
        children
      );
    }
  }]);

  return Form;
}(_react.Component);

exports.default = Form;


Form.propTypes = propTypes;
Form.defaultProps = defaultProps;
Form.displayName = 'Form';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-form/dist/Form.js
// module id = 671
// module chunks = 0